var _rect, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError5002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 289,
    viewBox: "0 0 458 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 155.402,
    y: 154.577,
    width: 162.962,
    height: 170.746,
    transform: "rotate(-38.5107 155.402 154.577)",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.591 102.5C299.591 125.195 290.314 145.723 275.347 160.5C260.628 175.03 240.907 177.5 218.591 177.5C191.972 177.5 167.833 171.238 152.96 151.5C142.683 137.861 142.091 120.892 142.091 102.5C142.091 81.3028 144.327 61.4959 157.591 46.9998C172.492 30.7137 194.276 20.9998 218.091 20.9998C240.407 20.9998 263.872 33.9692 278.591 48.4998C293.558 63.2767 299.591 79.8049 299.591 102.5Z",
    fill: "url(#paint1_radial)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.983 51.2159H34.9961V80.8547C37.8588 77.7047 41.8665 75.1274 47.0193 73.1229C52.1721 71.1183 57.7544 70.116 63.766 70.116C74.501 70.116 83.3752 72.5501 90.3888 77.4184C97.5455 82.2866 102.77 88.5866 106.062 96.3185C109.354 104.05 111 112.427 111 121.447C111 138.199 106.277 151.515 96.8298 161.395C87.383 171.132 74.0716 176 56.8956 176C45.4449 176 35.4971 174.067 27.0522 170.201C18.6074 166.192 12.0948 160.679 7.51451 153.663C2.93424 146.647 0.4294 138.557 0 129.394H35.8549C36.7137 133.832 38.7892 137.555 42.0812 140.562C45.3733 143.426 49.882 144.857 55.6074 144.857C62.3346 144.857 67.3443 142.71 70.6364 138.414C73.9284 134.119 75.5745 128.391 75.5745 121.232C75.5745 114.216 73.8569 108.847 70.4217 105.124C66.9865 101.401 61.9768 99.5401 55.3927 99.5401C50.5261 99.5401 46.5184 100.757 43.3694 103.191C40.2205 105.482 38.1451 108.561 37.1431 112.427H1.7176V18.9998H101.983V51.2159Z",
    fill: "#28293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.263 96.2855C336.263 71.714 341 52.3569 350.473 38.214C360.09 24.0712 375.52 16.9998 396.763 16.9998C418.006 16.9998 433.365 24.0712 442.838 38.214C452.455 52.3569 457.263 71.714 457.263 96.2855C457.263 121.143 452.455 140.643 442.838 154.785C433.365 168.928 418.006 176 396.763 176C375.52 176 360.09 168.928 350.473 154.785C341 140.643 336.263 121.143 336.263 96.2855ZM421.092 96.2855C421.092 81.8569 419.513 70.7855 416.356 63.0712C413.198 55.214 406.667 51.2855 396.763 51.2855C386.859 51.2855 380.328 55.214 377.171 63.0712C374.013 70.7855 372.434 81.8569 372.434 96.2855C372.434 106 373.008 114.071 374.156 120.5C375.305 126.785 377.601 131.928 381.046 135.928C384.634 139.785 389.874 141.714 396.763 141.714C403.653 141.714 408.82 139.785 412.265 135.928C415.853 131.928 418.222 126.785 419.37 120.5C420.518 114.071 421.092 106 421.092 96.2855Z",
    fill: "#28293D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 121.091,
    y: -0.000244141,
    width: 207.5,
    height: 206.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 236.883,
    y1: 154.577,
    x2: 236.883,
    y2: 325.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC2D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.337 72.2993) rotate(58.4124) scale(78.1915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#54556A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28293D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError5002);
export default __webpack_public_path__ + "static/media/error_500_2.d2030fd44d88c74bcee7688f364084c0.svg";
export { ForwardRef as ReactComponent };